import { styled } from "@mui/system";

const ListContainer = styled('ul')<{ marginLeft: string }>(({ marginLeft }) => ({
    listStyle: 'disc',
    padding: '0',
    margin: '0',
    marginLeft: marginLeft,
    '@media (max-width: 1024px)': {
        marginLeft: '16px',
    }
}));

interface ListProps {
    marginLeft?: string;
    children: React.ReactNode;
}

export const List = ({ marginLeft = '0', children }: ListProps) => {
    return <ListContainer marginLeft={marginLeft}>
        {children}
    </ListContainer>;
};
